import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useBudgetUnitCreateEditDispatch, useBudgetUnitCreateEditState } from './budget-unit-create-edit-context';
import BudgetUnitAppService from '../../../../application/platform/sge/budget-unit/budget-unit-app-service';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useBudgetUnitCreateEditController = () => {
    const navigate = useNavigate();
    const dispatch = useBudgetUnitCreateEditDispatch();
    const state = useBudgetUnitCreateEditState();
    const { showMessage, showLoading } = useBaseLayout();
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (state.budgetUnitId) {
            showLoading({ open: true });
            BudgetUnitAppService.getById(Number(state.budgetUnitId)).then((data) => {
                dispatch({ type: ACTION_TYPES.setBudgetUnitRequest, payload: { year: data.year, code: data.code, name: data.name } });
            }).catch((error: any) => {
                showMessage({ open: true, message: 'Não foi possível carregar os dados da unidade orçamentária', detail: error?.details || error?.message, type: 'error' });
            }).finally(() => {
                showLoading({ open: false });
            });
        }
    }, [state.budgetUnitId]);

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        const parsed = name === 'year' ? (value ? parseInt(value, 10) : undefined) : value;
        dispatch({ type: ACTION_TYPES.updateBudgetUnitRequest, payload: { [name]: parsed } });
    }

    async function handleSave() {
        if (!state.budgetUnitRequest.year || !state.budgetUnitRequest.code || !state.budgetUnitRequest.name) {
            dispatch({ type: ACTION_TYPES.setShowValidationErrors, payload: true });
            return;
        }
        setIsSaving(true);
        try {
            if (state.budgetUnitId) {
                await BudgetUnitAppService.edit(Number(state.budgetUnitId), state.budgetUnitRequest);
                showMessage({ open: true, message: 'Unidade orçamentária atualizada com sucesso!', type: 'success' });
            } else {
                await BudgetUnitAppService.add(state.budgetUnitRequest);
                showMessage({ open: true, message: 'Unidade orçamentária adicionada com sucesso!', type: 'success' });
            }
            setTimeout(() => navigate('/unidades-orcamentarias'), 1500);
        } catch (error: any) {
            showMessage({ open: true, message: 'Não foi possível salvar a unidade orçamentária', detail: error?.details || error?.message, type: 'error' });
        } finally {
            setIsSaving(false);
        }
    }

    function handleCancel() {
        navigate('/unidades-orcamentarias');
    }

    return { handleOnChange, handleSave, handleCancel, isSaving };
};
